module.exports = __webpack_public_path__ + "img/repor-distribution.78e759b0.svg";